import { AxiosRequestConfig } from 'axios';

class OtpRequestConfig {
  checkOtp = (otp: string): AxiosRequestConfig => ({
    url: 'otp/checkOtp',
    method: 'post',
    data: { otp }
  });

  deactivateOtp = (otp: string): AxiosRequestConfig => ({
    url: 'otp/deactivateOtp',
    method: 'post',
    data: { otp }
  });
}

export const otpRequestConfig = new OtpRequestConfig();
